import { useEffect, useState, useCallback } from 'react';
import { get } from '../api/axios';
import endpoints from '../api/endpoints';

let cachedOptions = null;
let fetchPromise = null;

const mapCategories = (list = []) =>
  list.map((c) => ({ value: c.id, label: c.name })).filter((c) => c.value);

const normalizeCategoryList = (result) => {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  return [];
};

const useCategories = () => {
  const [categories, setCategories] = useState(cachedOptions || []);
  const [loading, setLoading] = useState(!cachedOptions);

  useEffect(() => {
    if (cachedOptions) {
      setCategories(cachedOptions);
      setLoading(false);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = get(endpoints.getCategory)
        .then((res) => normalizeCategoryList(res?.data?.result))
        .then((list) => {
          cachedOptions = mapCategories(list);
          return cachedOptions;
        })
        .catch(() => {
          fetchPromise = null;
          return [];
        });
    }

    fetchPromise.then((opts) => {
      setCategories(opts);
      setLoading(false);
    });
  }, []);

  const getCategoryLabel = useCallback(
    (value) => categories.find((c) => String(c.value) === String(value))?.label,
    [categories]
  );

  return { categories, loading, getCategoryLabel };
};

export default useCategories;
